<template>
  <div class="privacy-act-statement">
    <p class="font-bold text-sm">
      Request for Change-of-Address and Forwarding Services
    </p>
    <p class="mt-2 text-sm">
      <strong>Privacy Act Statement: </strong> Your information will be used to provide mail forwarding and
      Change-of-Address (COA) services and move related advertisements, to verify your identity, to facilitate
      communication, to facilitate surveys regarding the COA process, to identify and mitigate potential fraud,
      and to provide address correction services. Collection is authorized by 39 U.S.C. 401, 403, 404.
      Providing the information is voluntary, but if not supplied, we may not be able to process and fulfill
      your request for services. We do not disclose your information to third parties without your consent,
      except to facilitate the transaction, to act on your behalf or request, or as legally required.
      <button
        v-if="!privacyActFullContent"
        class="c-link c-link--inline font-bold block mt-2 text-left text-sm"
        type="button"
        @click="togglePrivacyActContent"
      >
        Click here to display the entire Privacy Act Statement
      </button>
      <template v-if="privacyActFullContent">
        This includes the following standard
        and specific routine uses: Incident to legal proceedings; for law enforcement
        purposes; to a congressional office; to agents or contractors; to auditors;
        to labor organizations; to federal, state, local, or foreign government
        agencies; to agencies and entities for financial matters; for customer service
        purposes; to a federal, state, or local government agency upon certification
        when required for the performance of its duties; to a law enforcement agency
        after the Postal Inspection Service has confirmed that the COA information is
        needed for a criminal investigation; for service of process; for purpose of
        jury service; to agencies or entities at customer’s request; to a disaster
        relief organization; pursuant to the order of a court of competent jurisdiction;
        for address correction services only if the mailer is in possession of the name
        and old address; and to USPS licensed service providers to perform mailing list
        address correction services for lists containing your name and old address. For
        a list of licensed service providers please visit <a
          href="https://postalpro.usps.com/NCOALink_Service_Providers"
          target="_blank"
          rel="noopener noreferrer"
          class="c-link c-link--inline"
        >https://postalpro.usps.com/NCOALink_Service_Providers</a>. For more
        information regarding our privacy policies visit <a
          href="https://www.usps.com/privacypolicy"
          target="_blank"
          rel="noopener noreferrer"
          class="c-link c-link--inline"
        >www.usps.com/privacypolicy</a>.
        <button
          class="c-link c-link--inline text-sm"
          type="button"
          @click="togglePrivacyActContent"
        >
          Display Less
        </button>
      </template>
    </p>
  </div>
</template>

<script>
export default {
  name: 'PrivacyActStatement',
  data() {
    return {
      privacyActFullContent: false,
    };
  },
  methods: {
    togglePrivacyActContent() {
      this.privacyActFullContent = !this.privacyActFullContent;
    },
  },
};
</script>

<style scoped>
.privacy-act-statement a {
  overflow-wrap: break-word;
}
</style>
